<template>
  <div>
    <el-tree
      :data="selectData"
      show-checkbox
      default-expand-all
      node-key="value"
      ref="tree"
      highlight-current
      :default-checked-keys="defaultSelected"
      :props="defaultProps"
    >
    </el-tree>
    <div class="button">
      <div class="btn-option" @click="resetChecked">
        {{ $t("langcfg.txtClear") }}
      </div>
      <div class="btn-option" @click="exportFun('toudisk')">
        {{ $t("langcfg.txtExportToUdisk") }}
      </div>
      <div class="btn-option" @click="exportFun('tosharedfolder')">
        {{ $t("langcfg.txtExportToSharedFolder") }}
      </div>
    </div>
  </div>
</template>

<script>
import { License } from "../../../mixins";
import { saveExportOption } from "../../../settings";
import { isArray, logStdout } from "../../../shared/utils";

export default {
  mounted() {
    let arr = [];
    let settings = window.exportOptionSettings;
    let keys = Object.keys(settings);
    keys.forEach((key) => {
      if (settings[key] === true) {
        arr.push(key);
      }
    });
    this.defaultSelected = arr;
  },
  methods: {
    saveSettings() {
      let arr = this.$refs.tree.getCheckedKeys();
      let settings = window.exportOptionSettings;
      let keys = Object.keys(settings);
      keys.forEach((key) => {
        if (isArray(arr) && arr.indexOf(key) >= 0) {
          settings[key] = true;
        } else {
          settings[key] = false;
        }
      });
      saveExportOption(window.exportOptionSettings);
    },
    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    exportFun(dst) {
      let imageVideo = {
        imageVideo: []
      };
      let data = this.$refs.tree.getCheckedNodes();

      this.checkData.dryEye = [];
      this.checkData.Topography = [];
      for (let i = 0; i < data.length; i++) {
        if (
          data[i].type === "dryEye" &&
          data[i].labelName !== "Dryeye" &&
          data[i].labelName !== "Image/Video"
        ) {
          if (data[i].typeChild === "ImageVideo") {
            imageVideo.imageVideo.push({
              value: data[i].value
            });
          } else {
            this.checkData.dryEye.push({
              value: data[i].labelName
            });
          }
        } else if (data[i].type === "Topography" && data[i].labelName !== "Topography") {
          this.checkData.Topography.push({
            value: data[i].labelName
          });
        }
      }

      this.checkData.dryEye.push(imageVideo);
      this.$emit("exportStart", this.checkData, data.length, dst);
    }
  },
  mixins: [License],
  computed: {
    selectData: function () {
      let data = [];
      if (this.isDryEyeEnabled) {
        data.push(this.data_dryEye);
      }
      if (this.isTopographyEnabled) {
        data.push(this.data_Topo);
      }
      return data;
    }
  },
  watch: {
    hideOption() {
      if (this.hideOption === true) {
        this.saveSettings();
      }
    }
  },
  props: {
    hideOption: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      checkData: {
        dryEye: [],
        Topography: []
      },
      data_dryEye: {
        id: 1,
        label: this.$t("langcfg.txtDryEye"),
        type: "dryEye",
        labelName: "Dryeye",
        children: [
          {
            id: 3,
            type: "dryEye",
            label: this.$t("langcfg.txtExportTable"),
            labelName: "Table",
            value: "tableDryEye"
          },
          {
            id: 4,
            type: "dryEye",
            label: this.$t("langcfg.txtExportImageVideo"),
            labelName: "Image/Video",
            children: [
              {
                id: 5,
                type: "dryEye",
                typeChild: "ImageVideo",
                label: this.$t("langcfg.txtNibut"),
                value: "nibut",
                labelName: "Nibut"
              },
              {
                id: 6,
                type: "dryEye",
                typeChild: "ImageVideo",
                label: this.$t("langcfg.txtTearHeight"),
                value: "tearheight",
                labelName: "Tear Height"
              },
              {
                id: 7,
                type: "dryEye",
                typeChild: "ImageVideo",
                label: this.$t("langcfg.txtLipidLayer"),
                value: "lipidlayer",
                labelName: "Lipid Layer"
              },
              {
                id: 8,
                type: "dryEye",
                typeChild: "ImageVideo",
                label: this.$t("langcfg.txtMeibomian"),
                value: "meibomian",
                labelName: "Meibomian"
              },
              {
                id: 9,
                type: "dryEye",
                typeChild: "ImageVideo",
                label: this.$t("langcfg.txtEyelidEdge"),
                value: "eyelidedge",
                labelName: "Eyelid Edge"
              },
              {
                id: 10,
                type: "dryEye",
                typeChild: "ImageVideo",
                label: this.$t("langcfg.txtEyeRedness"),
                value: "eyeredness",
                labelName: "Eye Redness"
              },
              {
                id: 11,
                type: "dryEye",
                typeChild: "ImageVideo",
                label: this.$t("langcfg.txtOcularSurface"),
                value: "ocularsurface",
                labelName: "Surface"
              },
              {
                id: 16,
                type: "dryEye",
                typeChild: "ImageVideo",
                label: this.$t("langcfg.txtBut"),
                value: "fbut",
                labelName: "Fbut"
              },
              {
                id: 17,
                type: "dryEye",
                typeChild: "ImageVideo",
                label: this.$t("langcfg.txtBlink"),
                value: "blink",
                labelName: "Blink"
              }
            ]
          }
        ]
      },
      data_Topo: {
        id: 2,
        label: this.$t("langcfg.txtCornealTopography"),
        type: "Topography",
        labelName: "Topography",
        children: [
          {
            id: 12,
            type: "Topography",
            label: this.$t("langcfg.txtExportTable"),
            labelName: "Table",
            value: "tableTopography"
          },
          {
            id: 14,
            type: "Topography",
            label: this.$t("langcfg.txtOriginalImg"),
            labelName: "Original Photo",
            value: "originalimg"
          },
          {
            id: 15,
            type: "Topography",
            label: this.$t("langcfg.txtCornealTopography"),
            labelName: "Corneal topography",
            value: "map"
          },
          {
            id: 16,
            type: "Topography",
            label: ".eye",
            labelName: "eye",
            value: "eye"
          },
          {
            id: 17,
            type: "Topography",
            label: ".mwf",
            labelName: "mwf",
            value: "mwf"
          }
        ]
      },
      data: [],
      defaultProps: {
        children: "children",
        label: "label",
        labelName: "Dryeye"
      },
      defaultSelected: []
    };
  }
};
</script>

<style scoped lang="less">
/deep/ .el-tree {
  background: none;
}

/deep/ .el-tree-node__content:hover {
  background-color: #383b3f;
}

/deep/ .el-tree-node:focus > .el-tree-node__content {
  background-color: #383b3f;
}
/deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background: none;
}

/deep/ .el-tree-node__content {
  margin-top: 12px;
}

/deep/ .el-tree-node__label {
  font-size: 25px;
}

/deep/ .el-tree-node {
  padding-top: 5px;
}

/deep/ .ele-checkbox_inner {
  width: 30px;
  height: 30px;
}

.button {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.button > div {
  min-width: 100px;
  height: 40px;
  border: 1px solid #cccccc;
  line-height: 40px;
  text-align: center;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  font-size: 25px;
  padding: 5px;
}
.button > div:hover {
  background-color: #3f6ee8;
  border: 1px solid #3f6ee8;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/exportUserList/option.vue